var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoveItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.267,
    height: 20.26,
    viewBox: "0 0 20.267 20.263",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_open-plus",
    "data-name": "Icon open-plus",
    d: "M5.374,0V5.374H0V8.957H5.374v5.374H8.957V8.957h5.374V5.374H8.957V0Z",
    transform: "translate(10) rotate(45)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveItem);
export default __webpack_public_path__ + "static/media/remove-item.3a89910aea30df4888ee7729f227d32c.svg";
export { ForwardRef as ReactComponent };